import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PageHeader1 from "../../components/common/PageHeader1";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
// import st from "./DynamicForm.module.scss";

import _ from "lodash";
import { DataGrid } from "@mui/x-data-grid";
import { GetPlanListApi,handleDeletePlan } from "../../services/Plan";


function PlanList() {
  const navigate = useNavigate();
  const [ismodel, setIsModel] = useState(false);
  const [changeStatusTo, setChangeStatusTo] = useState({});
  const [getUserData, setgetUserData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [userList, setUserList] = useState([]);

  const { reset } = useForm();


  const getFilter = (data) => {
  
    setgetUserData(data)
  }

 

  const columns = () => {
    return [
      {
        field: "sno",
        headerName: "S.No.",
        sortable: true,
        width: 100,
      },
      
      {
        field: "name",
        headerName: "Name",
        sortable: true,
        width: 200,
      },
      {
        field: "type",
        headerName: "Type",
        sortable: true,
        width: 200,
      },
      {
        field: "price",
        headerName: "Price",
        sortable: true,
        width: 200,
      },
      {
        field: "isIntroductory",
        headerName: "Is Introductory Price",
        sortable: true,
        width: 200,
      },
      {
        field: "originalPrice",
        headerName: "Original Price",
        sortable: true,
        width: 200,
      },
      {
        field: "discountLabel",
        headerName: "Discount Label",
        sortable: true,
        width: 200,
      },

     
      {
        field: "action",
        headerName: "ACTION",
        sortable: false,
        width: 100,
        renderCell: (params) => (
          console.log("params", params),
          <div className="btn-group">
            {/* 
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => {
                getFilter(params.row)
              }}
            >
              <i className="icofont-eye-alt"></i>
            </button>
            */}
            {/* 👉 Edit Button */}
            <button
              type="button"
              className="btn btn-outline-primary ms-2 mt-2"
              onClick={() => navigate(`/create-plan/${params.row._id}`)}
            >
              <i className="icofont-ui-edit"></i>
            </button>
            
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={() => handleDeletePlan(params.row._id,getPlanList)}
            >
              <i className="icofont-ui-delete"></i>
            </button>
            
          </div>
        ),
      },
    ]
  };

  async function getPlanList() {
    setIsLoading(true);
    try {
      const response = await GetPlanListApi();
      const { data } = await response; // Assuming data is the array of users
      console.log("User List Data:", data);
  
      setUserList(
        data?.map((item, i) => {
          return {
            ...item,
            id: item?._id,
            sno: i + 1
          };
        }) || [] // Ensure setUserList gets an array even if data is null/undefined
      );
    } catch (error) {
      console.error("Error fetching product data:", error);
    } finally {
      reset();
      setIsLoading(false);
    }
  }  

  const clearData = () => {
    setgetUserData({});
    setChangeStatusTo({});
  }

  useEffect(() => {
    getPlanList()
  }, [])

  return (
    <div className="body d-flex py-lg-3 py-md-2">
      <div className="container-xxl">
        <PageHeader1
          pagetitle="Plans Information"
          modalbutton={() => {
            return (
              <div className="col-auto d-flex w-sm-100">
                <button
                  type="button"
                  className="btn btn-primary btn-set-task w-sm-100"
                  onClick={() => navigate("/create-plan")}
                >
                  <i className="icofont-plus-circle me-2 fs-6"></i>Add Plan
                </button>
              </div>
            );
          }}
        />

        <div className="row clearfix g-3">
          <div className="col-sm-12 mt-3">
            <div className="card">
              <div className="card-body">
                <div
                  id="myProjectTable_wrapper"
                  className="dataTables_wrapper dt-bootstrap5 no-footer"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      {userList && <DataGrid
                        rows={userList}
                        columns={columns()}
                        loading={isLoading}
                        pagination
                        initialState={{
                          ...userList.initialState,
                          pagination: { paginationModel: { pageSize: 8} },
                        }}
                        pageSizeOptions={[8, 10, 25, { value: -1, label: 'All' }]}
                        sx={{
                          border: "none",
                          "& .MuiDataGrid-root": {
                            border: "none",
                          },
                        }}
                      />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={ismodel}
        onHide={() => {
          clearData();
          setIsModel(false);
        }}
        style={{ display: "block" }}
      >
        <Modal.Header className="modal-header" closeButton>
          <h5 className="modal-title  fw-bold" id="expaddLabel">
            {changeStatusTo?.modelHeading}
          </h5>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <div className="deadline-form">
            <form>
              <h4
                style={{
                  textAlign: "center",
                  fontSize: "22px",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                Are you sure you want to change the status to{" "}
                {changeStatusTo.status}?
              </h4>
              
            </form>
          </div>
        </Modal.Body>
      </Modal>

   

    </div>
  );
}
export default PlanList;
